/*
    Custom JS
*/
if (document.querySelector("#newmode-embed-43053-43259")) {
    require(["https://engage.newmode.net/embed/43053/43259.js"]);
}
